require('./bootstrap');
import Alpine from 'alpinejs';
import '@fortawesome/fontawesome-free/css/all.min.css';
window.moment = require('moment');
window.ApexCharts = require('apexcharts');
window.Swal = require('sweetalert2');
window.Choices = require('choices.js');
import 'choices.js/src/styles/choices.scss';


window.geodesy = require('geodesy/osgridref.js');


$('#downloaddrop').on('hide.bs.dropdown', function (e) {
  if(e.clickEvent){
    let target = $(e.clickEvent.target);
    console.log(target.hasClass('downloadLink'));
    if(target.hasClass('downloadLink')){
      Livewire.emit('downloadFile',target.data('downloadid'));
    } else {
      console.log('close triggered');
      console.log(e);
      Livewire.emit('toggleDownloadDropdownClose');
    }
  }
})



$.ajaxSetup({
    cache: false,
    error: GlobalAjaxError,
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


window.modalLoadLive = function(url){
  $.ajax({
    url: url,
    method: 'get',
    success: function(result){

          $('#globalModalSlideBody').html(result);
          $('#globalModalSlide').modal({
            backdrop : 'static',
            show: true
          });
    },
    error: function(result){
      if(result.responseJSON.message !== undefined && result.responseJSON.message !== ''){
        alert(result.responseJSON.message);
      } else {
        alert('Oops - something went wrong!');
      }

    }
  })
}


window.placeSearch = null;
window.autocomplete = null;
window.componentForm = null;
window.Geocoder = null;
window.initAutocomplete = function(){
  // Create the autocomplete object, restricting the search predictions to
  // geographical location types.
  autocomplete = new google.maps.places.Autocomplete(
    document.getElementById('autocomplete'),
    { 
        types: ["geocode"] 
    }
  );
  // Avoid paying for data that you don't need by restricting the set of
  // place fields that are returned to just the address components.
  autocomplete.setFields(["address_component",'geometry']);
  // When the user selects an address from the drop-down, populate the
  // address fields in the form.
  
  document.getElementById('autocomplete').autocomplete='chrome-off';
}
window.initGeocoder = function(){
  Geocoder = new google.maps.Geocoder;
}

window.allowDrop = function(ev) {
  $(ev.target).addClass("drop-active");
  ev.preventDefault();
}

window.leaveDropZone = function(ev) {
  $(ev.target).removeClass("drop-active");
}

window.drop = function(ev) {
  $(ev.target).removeClass("drop-active");
}

window.blank_chart_options = {
    chart: {
      height: 350,
      type: 'bar',
    },
    colors : [
      '#005094',
      '#b1b1b1',
      '#ea5545',
      '#f46a9b', 
      '#ef9b20', 
      '#edbf33', 
      '#bdcf32', 
      '#87bc45', 
      '#27aeef', 
      '#b33dc6',
      '#ede15b'
    ],
    dataLabels: {
      enabled: false
    },
    series: [],
    title: {
      text: 'Loading...',
    },
    noData: {
      text: 'Loading...'
    },
    xaxis: {
      labels : {
        show: false
      }
    }
  }



// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
window.geolocate = function() {
    // hack the autocomplete to prevent browser autocomplete
    $('#autocomplete').attr('autocomplete','nope');
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            const geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
            const circle = new google.maps.Circle({
                center: geolocation,
                radius: position.coords.accuracy,
            });
            autocomplete.setBounds(circle.getBounds());
        });
    }
}

window.formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

window.formatterNumber = new Intl.NumberFormat('en-GB', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });



$(function() {
    "use strict";

    
    $('a.showAllTMActivity').on('click',function(e){
      e.preventDefault();
      $('.timeline-inverted').removeClass('hide');
      $(this).closest('LI.timeline-inverted').addClass('hide');
    })

    // this is for close icon when navigation open in mobile view
    $(".nav-toggler").on('click', function() {
        $("#main-wrapper").toggleClass("show-sidebar");
        $(".nav-toggler i").toggleClass("ti-menu");
    });
    $(".search-box a, .search-box .app-search .srh-btn").on('click', function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
    });

    // ============================================================== 
    // Resize all elements
    // ============================================================== 
    $("body, .page-wrapper").trigger("resize");
    $(".page-wrapper").delay(20).show();
    
    //****************************
    /* This is for the mini-sidebar if width is less then 1170*/
    //**************************** 
    var setsidebartype = function() {
        var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
        if (width < 1170) {
            $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
        } else {
            $("#main-wrapper").attr("data-sidebartype", "full");
        }
    };
    $(window).ready(setsidebartype);
    $(window).on("resize", setsidebartype);

    $(document).on("keydown", ":input:not(textarea):not(:submit):not(.allowentersubmit)", function(event) {
      return event.key != "Enter";
    });

    $(document).on('change','SELECT.newTaskProduct',function(){
      const parent = $(this).closest('DIV.removeabletaskproduct');
      const action = $('DIV.newTaskAction',parent);      
      const job_id = $(this).attr('data-job');
      const product_id = $('option:selected',this).val();
      const key_id = $(this).attr('data-key');
      

      if($('option:selected',this).attr('data-has-install') == 1 ){
        if(!jobInstallsURL){
          alert('You must select a job first!');
        } else {
          $('DIV.newTaskAction',parent).html('...checking...').load(jobInstallsURL, {
                                                                                'product_id': product_id,
                                                                                'key' : key_id,
                                                                              });  
        }
        
      } else {        
        $('DIV.newTaskAction',parent).html('');
      }

      updateTaskProductQualifications();

    })

    $(document).on('change','INPUT.newTaskOperative',function(){
      updateTaskProductQualifications();
    })

    $(document).on('click','A.removetaskfile',function(e){
      e.preventDefault();
      if(confirm('Are you sure?')){
        $(this).closest('LI.list-group-item').remove();
      }
    })

    $(document).on('click','A.dynamicremoverow',function(e){
      e.preventDefault();
      if(confirm('Are you sure?')){
        $(this).closest('DIV.row').remove();
      }
    })

    $(document).on('click','A.dynamicremovetablerow',function(e){
      e.preventDefault();
      if(confirm('Are you sure?')){
        $(this).closest('TR').remove();
      }
    })

    $(document).on('click','A.removetaskproduct',function(e){
      e.preventDefault();
      $(this).closest('DIV.removeabletaskproduct').remove();
      updateTaskProductQualifications();
    })

    $(document).on('click','A.dynamicaddtablerow',function(e){
      e.preventDefault();
      const url = $(this).attr('data-href');
      const target = $(this).attr('data-target');
      let _callback = false;
      if($(this).attr('data-callback')) _callback = $(this).attr('data-callback');
      $.ajax({
        url: url,
        type: 'GET',
        success: function(data){
          $(target).append(data);
          if(_callback){
            window[_callback]();
          }
        }

      })
    })

    

  // auto upload function, for on-screen loading
  $(document).on('change','INPUT.autoupload',function(){
    if($(this).val()){

      var ObjInput = $(this);
      var path = $(this).attr('data-path');
      var action = $(this).attr('data-action');
      var progresselement = $(this).attr('data-progress');
      var ObjProgress = $(progresselement);
      var ObjSubmit = $(this).closest('form').find(':submit');
      var singleUpload = $(this).attr('data-single-upload');
      var inputName = $(this).attr('data-input-name');

      var targetImage = $(this).attr('data-target-image');
      var targetFiles = $(this).attr('data-target-files');

      var tempID = 'loading_'+Date.now();

      if(!targetImage) targetImage = '#autouploadimages';
      if(!targetFiles) targetFiles = '#autouploadfiles';

      
      var formData = new FormData();      
      formData.append('file', $(this)[0].files[0]);     
      formData.append('input_name',inputName);
      formData.append('path',path);
      
      $(this).hide();
      
      $.ajax({
        url: action,  
        type: 'POST',
        xhr: function() {  
          var myXhr = $.ajaxSettings.xhr();
          if(myXhr.upload){ // Check if upload property exists
            myXhr.upload.addEventListener('progress',function(e){
              if(e.lengthComputable){
                ObjProgress.attr({value:e.loaded,max:e.total});
                console.log(e);
              }
            }, false); // For handling the progress of the upload
          }
          return myXhr;
        },
        beforeSend: function(){
          ObjProgress.val(0).attr('max',0);
          ObjProgress.show();   
          ObjSubmit.prop('disabled','diabled');
          
          if(singleUpload == 'true'){
            $(targetImage).html('<img id="' + tempID + '" src="' + strPathToRoot + '/img/uploading.svg" class="img-fluid d-block mx-auto">');
          } else {
            $(targetImage).append('<img id="' + tempID + '" src="' + strPathToRoot + '/img/uploading.svg" class="img-fluid d-block mx-auto">');
          }
          
        },
        success: function (response){
          ObjProgress.hide();
          ObjInput.show().val('');
          $('#'+tempID).remove();
          if(singleUpload == 'true'){
            $(targetFiles).html(response.file_input);
            $(targetImage).html(response.image_html);
          } else {
            $(targetFiles).append(response.file_input);
            $(targetImage).append(response.image_html);  
          }
          
          ObjSubmit.prop('disabled','');
        },
        error: function(){
          ObjProgress.hide();
          ObjInput.show().val('');
          alert('Error with upload');
          ObjSubmit.prop('disabled','');
        },
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json'
      });
    };
  });

  $(document).on('submit','FORM.confirmsubmit',function(e){
    var form = this;
    e.preventDefault();
    if(window.confirm('Are you sure you wish to do this?')){
      form.submit();
    }
  })

  $(document).on('submit','FORM.confirmsubmitswal',function (e, params) {
        var localParams = params || {};

        if (!localParams.send) {
            e.preventDefault();

            Swal.fire({
              title: $(this).data('title'),
              text: $(this).data('message'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Do it!',
              denyButtonText: 'Cancel',
            }).then((result) => {
              if (result.isConfirmed) {
                $(e.currentTarget).trigger(e.type, { 'send': true });
              }
            });
        }
    });

  $(document).on('click','A.confirmclick',function(e){
    return confirm('Are you sure you want to do this?');
  });

  $(document).on('click','a.modalload',function(e){
    e.preventDefault();
    var objLink = $(this);
    var slide = $(this).attr('data-slide');
    var secondmodal = $(this).attr('data-secondmodal');
    var confirm = $(this).attr('data-confirm');
    let doContinue = true;
    if(confirm){
      doContinue = window.confirm('Are you sure you want to do this?');
    }
    if(doContinue){
      objLink.addClass('disabled');
      $.ajax({
        url: $(this).attr('data-href'),
        method: 'get',
        success: function(result){
          if(slide == 'true'){
              $('#globalModalSlideBody').html(result);
              $('#globalModalSlide').modal({
                backdrop : 'static',
                show: true 
              }); 
          } else if(secondmodal == 'true') {
            $('#globalModal2').html(result);
            $('#globalModal2').modal({
              backdrop : 'static',
              show: true 
            });
          } else {
            $('#globalModal').html(result);
            $('#globalModal').modal({
              backdrop : 'static',
              show: true 
            });
          }
          objLink.removeClass('disabled');
          if (window.Livewire) {
              window.Livewire.rescan();
              console.log('Livewire rescan');
          }
        }, 
        error: function(result){
          if(result.responseJSON.message !== undefined && result.responseJSON.message !== ''){
            alert(result.responseJSON.message);
          } else {
            alert('Oops - something went wrong!');  
          }
          
          objLink.removeClass('disabled');
          objLink.prop('disabled','');
        }
      })
    }
  })


  $(document).on('submit','form.modalsubmit',function(e){
    e.preventDefault();
    var _continue = true;
    var _stayopen = false;
    if($(this).hasClass('confirm')){
      _continue = confirm('Are you sure?');
    }
    if($(this).hasClass('stayopen')){
      _stayopen = true;
    }
    if(_continue){
      var ObjSubmit = $(this).find(':submit');
      ObjSubmit.prop('disabled','disabled');
      $.ajax({
        url: $(this).attr('data-action'),
        method: $(this).attr('method'),
        data: $(this).serialize(),
        success: function(data){
          renderUIElements(data);
          ObjSubmit.prop('disabled','');
          if(!_stayopen) {
            $('#globalModal').modal('hide');
            $('#globalModalSlide').modal('hide');
          }
        },
        error: function(result){
          let err = JSON.parse(result.responseText);
          if(typeof err.errors != "undefined"){
            $('.error-response',$('#globalModal')).html('<strong>Errors:</strong><br>');
            $.each(err.errors, function(key, value){
              $('.error-response',$('#globalModal')).show();
              $('.error-response',$('#globalModal')).append(' - '+value+'<br>');
            });
          } else {
            console.log('error type undefined');
          }
          alert(err.message);  
          
          ObjSubmit.prop('disabled','');
        }
      })
    }
  })


  $(document).on('click','a.dynamicload',function(e){
    e.preventDefault();
    let _callback = false;
    var _continue = true;
    var _stayopen = false;
    if($(this).hasClass('confirm')){
      _continue = confirm('Are you sure?');
    }
    if($(this).attr('data-callback')) _callback = $(this).attr('data-callback');
    if(_continue){
      $.ajax({
        url: $(this).attr('data-href'),
        method: 'get',
        success: function(result){
          renderUIElements(result);
          if(_callback){
            window[_callback]();
          }
        }, 
        error: function(result){
          alert('Oops - something went wrong!');
        }
      })
    }
  })

  $(document).on('submit','FORM.dynamicload',function(e){
    e.preventDefault();
    let _callback = false;
    let _continue = true;
    let _stayopen = false;
    if($(this).hasClass('confirm')){
      _continue = confirm('Are you sure?');
    }
    let _method = $(this).attr('method');
    if(_continue){
      $.ajax({
        url: $(this).attr('data-action'),
        method: _method,
        data: $(this).serialize(),
        success: function(result){
          renderUIElements(result);
          if(_callback){
            window[_callback]();
          }
        }, 
        error: function(result){
          alert('Oops - something went wrong!');
        }
      })
    }
  })

  $(document).on('submit','form.modalload',function(e){
    e.preventDefault();

    let _continue = true;
    if($(this).hasClass('confirm')){
      _continue = confirm('Are you sure?');
    }
    let _method = $(this).attr('method');
    let _url = $(this).attr('action');


    if(_continue){
      $.ajax({
        url: _url,
        method: _method,
        data: $(this).serialize(),
        success: function(result){
          $('#globalModal').html(result);
            $('#globalModal').modal({
              backdrop : 'static',
              show: true
            });
        },
        error: function(result){
          alert('Oops - something went wrong!');
        }
      })
    }


  })


  setupSimpleMultiSelect();


});

window.setupSimpleMultiSelect = function(){
  $('.simpleMultipleSelect').fastselect({
      itemSelectedClass: 'd-none'
    }); 
}

function updateTaskProductQualifications(){
    
    var operatives = $('INPUT[name="operative[]"]:checked').map(function () {
        return $(this).val();
      }).get(); 

    // edit task page overrides the products, as there are no checkboxes available
    let products;
    if(typeof products_override !== 'undefined'){
      products = products_override;
    } else {
      products = $('SELECT.newTaskProduct').map(function () {
          return $(this).val();
        }).get();   
    }
    
    
    $('#productQualifications').html('...').load(productQualificationsURL, {'products[]': products, 'operatives[]' : operatives});
  }

window.renderUIElements = function(json_data){
  $.each(json_data, function(i, item){
    let _DOM = true;
    if(item.element == 'redirect') {
      window.location.replace(item.value);
      _DOM = false;
    } 
    if(item.element == 'alert') {
      alert(item.value);
      _DOM = false;
    }
    if(item.element == 'script') {
      eval(item.value);
      _DOM = false;
    }

    if(_DOM) {
      item.append === true ? $(item.element).append(item.value) : (item.prepend === true ? $(item.element).prepend(item.value) : $(item.element).html(item.value) );    
    }
      
  })
}

function GlobalAjaxError(x, e) {
  if (x.status == 0) {
    //alert('Error with network.\nPlease try again or contact us.');
  } else if (x.status == 404) {
    alert('404 Error - page could not be found.\nPlease try again or contact us at solutions@blumac.digital');
  } else if (x.status == 500) {
    alert('500 Error - Internal Server Error.\nPlease try again or contact us at solutions@blumac.digital');
  }  else {
    alert('Unknown Error - ' + x.responseText + '.\nPlease try again or contact us at solutions@blumac.digital');
  }
}
